import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { Box, createMuiTheme, Typography } from "@mui/material";
import { convertToRaw, EditorState } from "draft-js";
import { useFormik } from "formik";
import React from "react";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  image,
  lineHeight,
  link,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
} from "suneditor/src/plugins";
import * as yup from "yup";
import BasicButton from "../../components/common/button/BasicButton";
import { AsyncCreatableMultiSelect } from "../../components/common/customSelect/CustomCreate";
import CustomDialog from "../../components/common/dialog/CustomDialog";
import CustomInput from "../../components/common/textField/CustomInput";
import EmailViewer from "../../components/common2/EmailViewer";
import AddAttachmentBlobWithPreview from "../../components/EmailTemplates/AddAttachmentBlobWithPreview";
import { handleTime } from "../../components/helpers/helperFunctions";
import configs from "../../configs/config";
import LanguageData from "../../configs/LanguageData.json";
import { FileUpload } from "../../redux/actions/FileUpload/FileUpload";
import { ActionType } from "../../redux/actions/Snackbars";
import { IState } from "../../redux/reducers/rootReducers";
import {
  getTicketsById,
  sendEmailAfterTicketCreation,
} from "../../services/dashboard/dashboard.service";
import { getTimeLogs } from "../../services/timeline/timeline.service";
import moment from "moment";
export function addTargetBlankToLinks(html: string): string {
    let result = html.match(/<body[^>]*>([\s\S]*)<\/body>/i)?.[1] || html;
    result =  html.replace(/<a\b(?![^>]*\btarget=)[^>]*?>/gi, (match) => {
      return match.replace(/>$/, ' target="_blank">');
    });
    return `<div style="font-family: sans-serif">${result}</div>`;
}


const sendEmailAfterTicketCreationFun = async (payload: any) => {
  console.log("payload", payload);
  let newTicket: any = await sendEmailAfterTicketCreation(payload);
  return newTicket;
};

const getTicketsByIdFunc = async (id: any) => {
  let res = await getTicketsById(id);
  return res;
};
const emptyContentState = JSON.stringify(
  convertToRaw(EditorState.createEmpty().getCurrentContent())
);
const getTimeLineById = async (id: Number, pageCount: Number) => {
  let timelineLogs = await getTimeLogs(id, pageCount);
  return timelineLogs;
};

const CustomHookForFormik = (
  setIsSendEMailPopup: any,
  submittedData: any,
  type: any,
  setEditData: any,
  setData: any,
  source: any,
  setLoading: any,
  attachmentList: any
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ticketId } = useParams();
  const currAgent = useSelector(
    (state: IState) => state?.agentReducer?.loggedInAgent
  );

  const formik = useFormik({
    initialValues: {
      from: null,
      to: null,
      Emailsubject: null,
      defaultValueBody: emptyContentState,
      body: null,
      cc: null,
      bcc: null,
      optionsForTo: [],
      optionsForCC: [],
      optionsForBCC: [],
      optionsForSuggestion: [],
    },
    validationSchema: validationSchema,
    onSubmit: (values: any, actions) => {
      console.log("body", values);
      if(!values?.to?.length || values?.to?.length === 0 ){
        dispatch({
            type: ActionType.SNACKBAR,
            payload: {
              message: "This Email must have at least one recipient.",
              severity: "warning",
              open: true,
            },
          });
      }else{
      setLoading(true);
      const filteredArrayForTo = values?.to?.filter(
        (item: any) => item.label !== undefined
      );
      const filteredArrayForCC = values?.cc?.filter(
        (item: any) => item.label !== undefined
      );
      const filteredArrayForBCC = values?.bcc?.filter(
        (item: any) => item.label !== undefined
      );

      const StringTO = filteredArrayForTo
        ?.map((item: any) => item.value)
        .join(";");
      const StringCC = filteredArrayForCC
        ?.map((item: any) => item.value)
        .join(";");
      const StringBCC = filteredArrayForBCC
        ?.map((item: any) => item.value)
        .join(";");

      console.log("submittedData", submittedData);

      // let sourceTemp = source?.find((x: any) => x.name === "Email");

      let temp: any = ticketId;

      const attachmentPaths = attachmentList?.map((item: any) => {
        return { AttachmentPath: item.attachmentPath };
      });

      let payload = {
        sourceCode: configs.SOURCE,
        TicketLogs: {
          TicketId: type == "add" ? parseInt(submittedData.id) : parseInt(temp),
          name: "string",
          actions: submittedData?.template?.actions,
          companyName: "string",
          from: values?.from?.[0]?.id,
          to: StringTO ? StringTO : null,
          title: values?.Emailsubject,
          body: values.body,
          cc: StringCC ? StringCC : null,
          bcc: StringBCC ? StringBCC : null,
          description: "string",
          roleId: 0,
          sourceCode: configs.SOURCE,
          isActive: true,
          ticketLogAttachmentsList: attachmentPaths,
        },
      };
      sendEmailAfterTicketCreationFun(payload).then((res) => {
        if (res?.status == 200) {
          setLoading(false);
          setIsSendEMailPopup(false);
          dispatch({
            type: "SEND_EMAIL_VIEW",
            payload: null,
          });
          if (type == "history") {
            getTimeLineById(Number(ticketId), 0).then((res1: any) => {
              console.log("addfromtimeline", res1);

              if (res1?.ticketLog?.length > 0) {
                setData({
                  logData: res1?.ticketLog,
                  totalEfforts: res1?.totalEfforts,
                });
              } else {
              }
            });
          }
          if (type == "edit") {
            getTicketsByIdFunc(Number(ticketId)).then((res) => {
              console.log("getTicketsByIdFunc", res);
              setEditData(res);
            });
            // navigate(-1)
            // navigate(`/TicketManagement?assignee=${currAgent.id}`);
          }
          if (type == "add" || type == "edit") {
            navigate(`/TicketManagement?assignee=${currAgent.id}`);
            //dispatch(newFilterAllTickets(AllInfo?.statusTypes));
            // navigate("/TicketManagementSys");
          } else {
            // navigate(`/TicketManagement?assignee=${currAgent.id}`);
          }

          dispatch({
            type: ActionType.SNACKBAR,
            payload: {
              message: LanguageData.EMAIL_UPDATED_SUCESSFULLY,
              severity: "success",
              open: true,
            },
          });
        } else {
          console.log("sendEmailAfterTicketCreationFun", res);
          setLoading(false);
          dispatch({
            type: ActionType.SNACKBAR,
            payload: {
              message: "Email sending failed! please try again after sometime",
              severity: "error",
              open: true,
            },
          });
        }
      }).catch((err:any)=>{
        console.log("sendEmailAfterTicketCreationFun_err",err)
      });
      }
    },
  });
  return formik;
};

const validationSchema = yup.object({
  to: yup
    .array()
    .max(1000, "Subject is lengthy(Allowed character length is 10)")
    .required("required"),
  Emailsubject: yup
    .string()
    .max(1000, "Subject is lengthy(Allowed character length is 10)"),
});

const SendEmailPopup = ({
  setIsSendEMailPopup,
  isSendEmailPopup,
  submittedData,
  type,
  filterEmailData,
  setEditData,
  setData,
  formData,
}: {
  setIsSendEMailPopup: any;
  isSendEmailPopup: any;
  submittedData: any;
  type: any;
  filterEmailData: any;
  setEditData: any;
  setData?: any;
  formData?: any;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const defaultTheme = createMuiTheme();
  Object.assign(defaultTheme, {
    overrides: {
      MUIRichTextEditor: {
        root: {
          marginTop: 0,
          height: "auto",
          // minHeight:"100px"
        },
        editor: {
          borderBottom: "1px solid gray",
          minHeight: "100px",
          fontSize: "14px",
        },
      },
    },
  });

  const formRef = React.useRef<any>(null);
  const [viewOnly, setViewOnly] = React.useState<boolean>(submittedData?.view || false);
  const [isLoading, setIsLoading] = React.useState<any>(true);
  const [loading, setLoading] = React.useState<any>(false);

  const currOrganisation = useSelector(
    (state: IState) => state?.FreeTrialReducer?.getLoggedOrganisation // current org
  );
  const allEmailTemplates = useSelector((state: IState) => state?.EmailTemplatesReducer?.AllEmailTemplates);
  const currAgent = useSelector(
    (state: IState) => state?.agentReducer?.loggedInAgent
  );
  const [attachmentList, setAttachmentList] = React.useState<any>([]);
  const [emailTemplateRecipients, setEmailTemplateRecipients ] = React.useState<string[]>([]);
  const onImageUploadBefore = (files: any, info: any, uploadHandler: any) => {
    const uploadCB = (resStatus: string, res: any) => {
      if (resStatus !== "0") return;
      let { filePath = "", name = "", fileSize = 0 } = res?.data;
      console.log("uploadesRes", res.data);
      const response = {
        result: [
          {
            url: filePath,
            name: name,
            size: fileSize,
          },
        ],
      };
      uploadHandler(response);
    };
    let fileObject = {
      description: "First File",
      filetypeid: 1,
      ExtensionTypeId: 1,
      name: "email-photo",
      formFile: files[0],
    };
    dispatch(
      FileUpload(
        fileObject,
        () => {},
        false,
        uploadCB,
        () => {},
        "quicksendmailattachment"
      )
    );
  };

  const formik = CustomHookForFormik(
    setIsSendEMailPopup,
    submittedData,
    type,
    setEditData,
    setData,
    formData?.source,
    setLoading,
    attachmentList
  );

  React.useEffect(() => {
    return () => {
      handleTime.cancel(); 
    };
  }, []);

  React.useEffect(() => {
    if(allEmailTemplates && allEmailTemplates?.length > 0){
      const recipients:string[] =  []
      allEmailTemplates.filter((item:any)=>{
        if(item.from){
          recipients.push(`${item.from}`.toLowerCase());
        }
      });
      const uniqueArr = Array.from(new Set(recipients));
      setEmailTemplateRecipients(uniqueArr);
    }
  }, [allEmailTemplates?.length]);



  
  const runUpdate = () => {
    setAttachmentList(submittedData?.template?.emailTemplateAttachmentList || submittedData?.ticketLogs?.ticketLogAttachmentsList || []);

    // const {view} = submittedData;
    const subjectVal = submittedData?.template?.subject || submittedData?.ticketLogs?.title || "";
    // Parse dynamic fields
    const bodyVal = submittedData?.template?.body || submittedData?.ticketLogs?.body || "<div></div>";
    const body = parseDynamicFields(bodyVal, submittedData, currOrganisation, currAgent);
    const subject = parseDynamicFields(subjectVal, submittedData, currOrganisation, currAgent);
    const tempFrom:string = submittedData?.template?.from || submittedData?.ticketLogs?.from || "";
    const from = [];
    
    // Build recipients 
    let toList = buildRecipientList("to", submittedData, filterEmailData);
    let ccList = buildRecipientList("cc", submittedData, filterEmailData);
    let bccList = buildRecipientList("bcc", submittedData, filterEmailData);
    
    if (tempFrom) {
      from.push({ label: tempFrom,name: tempFrom,value: tempFrom,id: tempFrom});
      toList = toList.filter(i=>i.label.toLowerCase() !== tempFrom.toLowerCase());
      ccList = ccList.filter(i=>i.label.toLowerCase() !== tempFrom.toLowerCase());
      bccList = bccList.filter(i=>i.label.toLowerCase() !== tempFrom.toLowerCase());
    }


    // Prepare updates for Formik
    formik.setFieldValue("to", toList);
    formik.setFieldValue("type", submittedData?.ticketLogs?.type || "Outgoing");
    formik.setFieldValue("cc", ccList);
    formik.setFieldValue("bcc", bccList);
    formik.setFieldValue("from", from);
    formik.setFieldValue("optionsForBCC", bccList);
    formik.setFieldValue("optionsForCC", ccList);
    formik.setFieldValue("optionsForTo", toList);
    formik.setFieldValue("Emailsubject", subject);

    let formttedBody =  addTargetBlankToLinks(body);
    formik.setFieldValue("body", formttedBody);
  }

  React.useEffect(() => {
    if (!submittedData || !currOrganisation) return;
      runUpdate();
  }, [submittedData, currOrganisation,filterEmailData]);

  const checkRecipientInTemplate = (email:string) => { 
    if(!emailTemplateRecipients?.some) return false;
    return emailTemplateRecipients.some((i:string)=>{
      return email.toLowerCase().includes(i.toLowerCase());
    });
  }
  const actionsHandler = (type : "reply" | "replyAll" | "forward") => {
    setViewOnly(false);
    console.log("submittedData",submittedData,formik.values);
    const {from,cc=[],to=[],bcc=[], body, Emailsubject} = formik.values;
    
    let toAddress:dropdownOption[] = [];
    let ccAddress:dropdownOption[] = [];
    let bccAddress:dropdownOption[] = [];
    let fromAddress:dropdownOption[] = [];
    let prefillText = type === "forward" ? "Fwd: " : "Re: ";

    


    if(type==="replyAll"){
      toAddress = [...to,...from].filter((i:any)=>!checkRecipientInTemplate(i.name));
      fromAddress = [...cc,...to,...bcc].filter((i:any)=>checkRecipientInTemplate(i.name));
    }

    if(type==="reply"){
      toAddress = from;
      fromAddress = [...cc,...to,...bcc].filter((i:any)=>checkRecipientInTemplate(i.name));
    }


    ccAddress = type==="reply" ? [] : cc;
    bccAddress = type==="reply" ? [] : bcc;

    if(type === "forward"){
      fromAddress = submittedData?.type === "Outgoing" ? from : [...cc,...to,...bcc].filter((i:any)=>checkRecipientInTemplate(i.name));
      toAddress = [];
      ccAddress = [];
      bccAddress = [];
    }

    toAddress = toAddress.filter((i:any)=>!checkRecipientInTemplate(i.name));
    ccAddress = ccAddress.filter((i:any)=>!checkRecipientInTemplate(i.name));
    bccAddress = bccAddress.filter((i:any)=>!checkRecipientInTemplate(i.name));


    formik.setFieldValue("to", toAddress);
    formik.setFieldValue("optionsForTo", toAddress);

    formik.setFieldValue("cc", ccAddress);
    formik.setFieldValue("optionsForCC", ccAddress);

    formik.setFieldValue("bcc", bccAddress);
    formik.setFieldValue("optionsForBCC", bccAddress);

    formik.setFieldValue("Emailsubject", prefillText + Emailsubject);

    formik.setFieldValue("from", fromAddress);

    const formattedCreatedDate = submittedData?.ticketLogs?.createdDateTime ? moment(submittedData?.ticketLogs?.createdDateTime).format("ddd, MMM D, YYYY [at] h:mm A") : "";
    let formattedBody = ""
    if(type==="reply" || type==="replyAll"){ 
      formattedBody = `<div>
      <div><br/><br/><br/><br/></div>
      <b>On ${formattedCreatedDate} &lt;${from?.[0]?.id}&gt; wrote:</b>
      <div><br/></div>
      <blockquote style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex">
      ${body}
      </blockquote></div>`;
    }else{

      
      const frwdTo = to.length > 0 ? `To: ${(to || []).map((i:any)=>("&lt;" + i.id + "&gt;"))}<br/>` : "";
      const frwdCC = cc.length > 0 ? `CC: ${(bcc || []).map((i:any)=>("&lt;" + i.id + "&gt;"))}<br/>` : "";
      const frwdBCC = bcc.length > 0 ? `BCC: ${(bcc || []).map((i:any)=>("&lt;" + i.id + "&gt;"))}<br/>` : "";
      formattedBody = `<div>
      <div><br/><br/><br/><br/></div>
      <b>
        ---------- Forwarded message ---------<br/>
        From: &lt;${from?.[0]?.id}&gt;<br/>
        Date: ${formattedCreatedDate}<br/>
        Subject: ${Emailsubject}<br/>
        ${frwdTo}
        ${frwdCC}
        ${frwdBCC}
      </b>
      <div><br/></div>
      <blockquote style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex">
      ${body}
      </blockquote></div>`;
    } 
    formik.setFieldValue("body", formattedBody);


  }
  const resendHandler = () => {
    setViewOnly(false);
  }
  const customHeader = () => {
    return (
      <Box className="row m-0 justify-content-between align-items-center" >
        <Box>
          {formik?.values?.Emailsubject || "Send email"}
        </Box>
        <Box className="row m-0 gap5 align-items-center">
          {viewOnly && <>
            {(submittedData?.type === "Incoming") &&<>
            <BasicButton onClick={() => {actionsHandler("reply")}} label={"Reply"} />
            <BasicButton onClick={() => {actionsHandler("replyAll")}} label={"Reply All"} />
            </>}
            <BasicButton onClick={() => {actionsHandler("forward")}} label={"Forward"} />
            {(submittedData?.type === "Outgoing") &&
              <BasicButton onClick={resendHandler} label={"resend"} />
            }
          </>}
        </Box>
      </Box>
    )
  }
  return (
    <>
      <CustomDialog
        className="send-email-popup"
        heading={<>{customHeader()}</>}
        body={
          <>
            {isLoading ? (
              <form ref={formRef} onSubmit={formik.handleSubmit}>
                <Box>
                  {viewOnly ?
                    <Box>
                      {(formik?.values?.from?.[0]?.id) &&
                        <Typography className="send-email-field-div recipient-row">
                          <span className="recipient-row-title">From</span>:
                          <span className="recipient"> {formik?.values?.from?.[0]?.id}</span>
                        </Typography>
                      }
                      {(formik?.values?.to && formik?.values?.to?.length > 0) &&
                        <Typography className="send-email-field-div recipient-row">
                          <span className="recipient-row-title">TO</span> :
                          {formik.values.to?.map((item: any, index: number) => (
                            <span className="recipient" key={item}> {item.label}</span>
                          ))}
                        </Typography>
                      }
                      {(formik?.values?.cc && formik?.values?.cc?.length > 0) &&
                        <Typography className="send-email-field-div recipient-row">
                          <span className="recipient-row-title">CC</span> :
                          {formik.values.cc?.map((item: any, index: number) => (
                            <span className="recipient" key={item}> {item.label}</span>
                          ))}
                        </Typography>
                      }
                      {(formik?.values?.bcc && formik?.values?.bcc?.length > 0) &&
                        <Typography className="send-email-field-div">
                          <span className="recipient-row-title">BCC</span> :
                              {formik.values.bcc?.map((item: any, index: number) => (
                                <span className="recipient" key={item}> {item.label}</span>
                              ))}
                        </Typography>
                      }
                    </Box>

                    :

                    <Box className="send-email-field-div">
                      <Box>
                        {(formik?.values?.from?.[0]?.id) ?
                          <Typography className="send-email-field-div recipient-row">
                            <span className="recipient-row-title">From</span>:
                            <span className="recipient"> {formik?.values?.from?.[0]?.id}</span>
                          </Typography>
                          :
                          <>
                          <Typography className="txt-danger">
                            The email service used for this ticket either does not exist or is inactive. Please contact your system administrator
                          </Typography>
                          </>
                        }
                      </Box>
                      <Box>
                        <div style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          alignItems: "center",
                        }}>
                          <div style={{ fontSize: "14px" }}>TO&nbsp;:&nbsp;</div>
                          <div style={{ width: "100%" }}>
                            <AsyncCreatableMultiSelect
                              name="to"
                              defaultValue={formik.values.to}
                              // placeholder="Please Enter TO address"
                              placeholder=""
                              handleInputChange={(e: any) => {
                                formik.setFieldValue("to", e);
                              }}
                            />
                          </div>
                        </div>
                      </Box>
                      <Box>
                        <>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                          }}>
                            <div style={{ fontSize: "14px" }}>CC&nbsp;:&nbsp;</div>
                            <div style={{ width: "100%" }}>
                              <AsyncCreatableMultiSelect
                                name="cc"
                                defaultValue={formik.values.cc}
                                // placeholder="Please Enter CC address"
                                placeholder=""
                                handleInputChange={(e: any) => {
                                  formik.setFieldValue("cc", e);
                                }}
                              />
                            </div>
                          </div>
                        </>
                      </Box>

                      <Box>
                        <>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                          }}>
                            <div style={{ fontSize: "14px" }}>BCC&nbsp;:&nbsp;</div>

                            <div style={{ width: "100%" }}>
                              <AsyncCreatableMultiSelect
                                name="bcc"
                                defaultValue={formik.values.bcc}
                                // placeholder="Please Enter BCC address"
                                placeholder=""
                                handleInputChange={(e: any) => {
                                  formik.setFieldValue("bcc", e);
                                }}
                              />
                            </div>
                          </div>
                        </>
                      </Box>

                      <Box>
                        <div style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          alignItems: "center",
                        }}>
                          <div style={{ fontSize: "14px", paddingBottom: "5px" }}>Subject&nbsp;:&nbsp;</div>
                          <div style={{ width: "100%" }} className="">
                            <CustomInput
                              isDisabled={viewOnly}
                              readOnly={false}
                              onClick={null}
                              iconPosition={"start"}
                              icon={false}
                              isError={
                                formik.touched.Emailsubject &&
                                Boolean(formik.errors.Emailsubject)
                              }
                              label={"Enter the Notes"}
                              name="Emailsubject"
                              value={formik.values.Emailsubject}
                              onChange={formik.handleChange}
                              helperText={
                                formik.touched.Emailsubject &&
                                formik.errors.Emailsubject
                              }
                              placeholder={"Subject"}
                            />{" "}
                          </div>
                        </div>
                      </Box>
                    </Box>
                    }

                  <Box>
                    <div className="pb-1">
                      <AddAttachmentBlobWithPreview
                        btnLabel={"Add attachments"}
                        accept={".pdf,.doc,.docx,.jpg,.jpeg,.png,.zip,.txt,.xls,.xlsx,.mp4,.bmp"}
                        type="Attachment"
                        isAttachmentOnFly={true}
                        isShowBtn={viewOnly ? false : true}
                        attachmentList={attachmentList}
                        setAttachmentList={setAttachmentList}
                      />
                    </div>
                  </Box>

                  <Box>
                    <div
                      style={{
                        overflow: "auto",
                        width: "100%",
                      }}
                    >
                    {viewOnly ?
                      <Box className="text-box-like-border">
                        <EmailViewer body={`${formik?.values?.body||""}`} />
                      </Box>
                    :
                      <SunEditor
                        autoFocus={true}
                        lang="en"
                        setOptions={{
                          showPathLabel: false,
                          minHeight: "50vh",
                          imageResizing: false,   // disable drag resize
                          imageWidth: "auto",   // keep original size
                          maxHeight: "50vh",
                          placeholder: "Enter your text here!!!",
                          plugins: [
                            align,
                            font,
                            fontColor,
                            fontSize,
                            formatBlock,
                            hiliteColor,
                            horizontalRule,
                            lineHeight,
                            list,
                            paragraphStyle,
                            table,
                            template,
                            textStyle,
                            image,
                            link,
                          ],
                          buttonList: [
                            ["undo", "redo"],
                            ["font", "fontSize", "formatBlock"],
                            ["paragraphStyle"],
                            [
                              "bold",
                              "underline",
                              "italic",
                              "strike",
                              "subscript",
                              "superscript",
                            ],
                            ["fontColor", "hiliteColor"],
                            ["removeFormat"],
                            "/", // Line break
                            ["outdent", "indent"],
                            ["align", "horizontalRule", "list", "lineHeight"],
                            ["table", "link", "image"],
                          ],
                          formats: [
                            "p",
                            "div",
                            "h1",
                            "h2",
                            "h3",
                            "h4",
                            "h5",
                            "h6",
                          ],
                          font: [
                            "Arial",
                            "Calibri",
                            "Comic Sans",
                            "Courier",
                            "Garamond",
                            "Georgia",
                            "Impact",
                            "Lucida Console",
                            "Palatino Linotype",
                            "Segoe UI",
                            "Tahoma",
                            "Times New Roman",
                            "Trebuchet MS",
                          ],
                          imageMultipleFile: true,
                        }}
                        // onImageUpload={()=>{
                        //   console.log('upload Progress')
                        // }}
                        onImageUploadBefore={onImageUploadBefore}
                        //imageMultipleFile={true}
                        defaultValue={"<div></div>"}
                        setContents={formik.values.body}
                        onChange={(content: string) => {
                          // handleChange(content)
                          formik.setFieldValue("body", content);
                        }}
                      />
                    }
                    </div>
                  </Box>
                </Box>
              </form>
            ) : (
              "loading"
            )}
          </>
        }
        open={isSendEmailPopup}
        handleClose={() => {
          setIsSendEMailPopup(false);
          dispatch({
            type: "SEND_EMAIL_VIEW",
            payload: null,
          });
          type == "add" &&
            navigate(`/TicketManagement?assignee=${currAgent.id}`);
        }}
        footer={
          <>
            <div style={{ display: "flex", gap: 10 }}>
              <BasicButton
                onClick={() => {
                  setIsSendEMailPopup(false);
                  dispatch({
                    type: "SEND_EMAIL_VIEW",
                    payload: null,
                  });
                  if (type == "edit") {
                  } else {
                    if (type == "history") {
                    } else {
                      navigate(`/TicketManagement?assignee=${currAgent.id}`);
                    }
                  }
                }}
                type={"cancel"}
                isLoading={false}
                isDisabled={false}
                color="primary"
                size="large"
                label={"Cancel"}
                variant={"outlined"}
                endIcon={<CloseIcon sx={{ width: "20px" }} />}
              />
              <form onSubmit={formik.handleSubmit}>
                <BasicButton
                  onClick={() => {}}
                  type="submit"
                  label={"Send"}
                  isLoading={loading}
                  disabled={viewOnly || !formik?.values?.from?.[0]}
                  color="primary"
                  size="large"
                  variant={"contained"}
                  endIcon={<SendIcon sx={{ width: "20px" }} />}
                />
              </form>
            </div>
          </>
        }
      />
    </>
  );
};









type SubmittedData = {
  template?: Record<string, string>;
  view?: boolean;
  addUpdate?: boolean;
  ticketLogs?: {
    secondaryContacts?: { email?: string };
    contacts?: { email?: string };
    agent?: { email?: string };
    circulationListTO?: string;
    circulationListCC?: string;
    circulationListBCC?: string;
    to?: string;
    cc?: string;
    bcc?: string;

  };
};

type FilterEmailData = {
  selectedTo?: { label: string }[];
  selectedCc?: { label: string }[];
  selectedBcc?: { label: string }[];
  selectedCC?: { label: string }[];
  selectedBCC?: { label: string }[];
  selectedbcc?: { label: string }[];
  selectedcc?: { label: string }[];
  selectedto?: { label: string }[];
};

type dropdownOption = {
      label: string,
      name: string,
      value: string,
      id: string,
}

// Utility: replace template placeholders with actual values
const replacePlaceholders = (input: string, replacements: Record<string, string | undefined>): string => {
  let result = input;
  for (const [placeholder, value] of Object.entries(replacements)) {
    if (value) {
      result = result.replaceAll(`{{${placeholder}}}`, value);
    }
  }
  return result;
};

// Common function to build recipient list
const buildRecipientList = (
  type: "to" | "cc" | "bcc",
  submittedData: SubmittedData,
  filterEmailData: FilterEmailData
): dropdownOption[] => {
  let recipients: string[] = [];
  /*=================== FETCH on view from Timeline =================== */
  if (submittedData.view) {
    // const fallback = submittedData?.ticketLogs?.[`circulationList${type.toUpperCase()}` as keyof typeof submittedData.ticketLogs] as string | undefined;
    const fallback1 = submittedData?.ticketLogs?.[`${type}` as keyof typeof submittedData.ticketLogs] as string | undefined;
    recipients = recipients.concat(fallback1?.split(";") ?? []);
    //.concat(fallback1?.split(";") ?? []);
  } else {
    if (submittedData?.template) {
      /*=================== Fetch Values from Email Template =================== */
      let templateVal = submittedData?.template?.[type] ?? "";

      // Replace placeholders
      templateVal = replacePlaceholders(templateVal, {
        SecondaryContactEmail: submittedData?.ticketLogs?.secondaryContacts?.email,
        PrimaryContactEmail: submittedData?.ticketLogs?.contacts?.email,
        Owner_Email: submittedData?.ticketLogs?.agent?.email,
      });


      // Add template values
      if (templateVal) {
        recipients = recipients.concat(templateVal.split(";"));
      }
    }

    /*=================== Fetch Values from Circulation List (Only on ADD & EDIT) =================== */
    if(filterEmailData){
      filterEmailData.selectedbcc = filterEmailData.selectedBCC;
      filterEmailData.selectedcc = filterEmailData.selectedCC;
      filterEmailData.selectedto = filterEmailData.selectedTo;
    }
    const selected = filterEmailData?.[`selected${type}` as keyof FilterEmailData] as { label: string }[] | undefined;
    if (selected?.length) {
      recipients = recipients.concat(selected.map(item => item.label));
    }

    /*===========     ADD UPDATE    ============ */

    if(submittedData.addUpdate){
      const fallback = submittedData?.ticketLogs?.[`circulationList${type.toUpperCase()}` as keyof typeof submittedData.ticketLogs] as string | undefined;
      recipients = recipients.concat(fallback?.split(";") ?? []);
    }
  }
  // Deduplicate + clean
  const uniqueRecords = Array.from(new Set(recipients.map(e => e.trim()).filter(Boolean)));
  return uniqueRecords.map((item) => ({
    label: item,
    name: item,
    value: item,
    id: item,
  }));
};






/* ================== PARSE DYNAMIC FIELDS =================== */

const parseFun = (data: any, key: any) => {
  if (data) {
    return data?.replace(/{{(?!Sur_)(.+?)}}/g,(match: any, cap1: any) => key[cap1]);
  } else {
    return "";
  }
};

const formatTextaredata = (data: string="") => {
  if (!data) {
    return "";
  } else {
    return `${data.replace(/\n/g, "<br/>")}<br/>`; 
    //`<span style="white-space: pre-wrap; word-wrap: break-word;">${data}</span>`
  }
}
const parseDynamicFields = (content:string,submittedData:any,currOrganisation:any,currAgent:any) => {
  const ticketLogs = submittedData?.ticketLogs ?? {};
  const agent = ticketLogs?.agent ?? {};
  const contacts = ticketLogs?.contacts ?? {};
  const secondaryContacts = ticketLogs?.secondaryContacts ?? {};
  const manager = ticketLogs?.manager ?? {};
  const user = ticketLogs?.user ?? {};

  const replacements: Record<string, any> = {
    organisation_name: currOrganisation?.name ?? "-",
    Owner_name:ticketLogs?.agent?.firstName ??"-",
    Owner_Name:ticketLogs?.agent?.firstName ??"-",
    Group_name:ticketLogs?.group?.name ??"-",
    ManagerEmai:ticketLogs?.manager?.name ??"-",
    Owner_Emai: ticketLogs?.agent?.firstName ??"-",
    ticket_id: submittedData?.id ?? "-",
    Title: ticketLogs?.title ?? "-",
    Note: formatTextaredata(ticketLogs?.note),
    Effort: submittedData?.totalEffort ?? "-",
    Description: formatTextaredata(ticketLogs?.description),
    Category: ticketLogs?.category?.name ?? "-",
    Status: ticketLogs?.ticketStatus?.name ?? "-",
    TicketType: ticketLogs?.ticketType?.name ?? "-",
    Priority: ticketLogs?.priority?.name ?? "-",
    Sla: ticketLogs?.sla ?? "-",
    OpenDateTime: ticketLogs?.openDateTime ?? "-",
    DueDateTime: ticketLogs?.dueDateTime ?? "-",
    FirstResponseDueDateTime: ticketLogs?.firstResponseDueDateTime ?? "-",
    ScheduleDateTime: ticketLogs?.scheduleDateTime ?? "-",
    CreatedDateTime: ticketLogs?.createdDateTime ?? "-",
    Group_Id: ticketLogs?.group?.name ?? "-",
    Owner_Id: agent?.firstName ?? "-",
    NextActionDescription: ticketLogs?.nextActionDescription ?? "-",
    PrimaryContactEmail: contacts?.email ?? "-",
    KnownAs: contacts?.knownAs ?? "-",
    ActionBy: currAgent ? `${currAgent?.firstName} ${currAgent?.lastName}`  :  "-",
    ManagerName: manager?.name ?? "-",
    Owner_Email: agent?.email ?? "-",
    SecondaryContactEmail: secondaryContacts?.email ?? "-",
    OutComeCategory: ticketLogs?.outcomeCategory ?? "-",
    HyperlinkTicketId: submittedData?.hyperlinkTicketId ?? "-",
    Webform :   `<a href=${window.location.origin}/#/WebformValues?ticketId=${submittedData?.id}&ticketLogId=${ticketLogs?.id}>Open Webform</a>`,
    SSOWebform:`<a href=${window.location.origin}/#/WebformValuesSSO?ticketId=${submittedData?.id}&ticketLogId=${ticketLogs?.id}>Open Webform</a>`,
    
    // `WebformValues?ticketId=${submittedData?.id }&ticketLogId=${ticketLogs?.id}`,
  };
  const parsedContent = parseFun(content, replacements);
  return parsedContent;
};

export default SendEmailPopup;
